import React from 'react';
import styled from 'styled-components';
import { FaBuilding, FaMapMarkerAlt, FaClock, FaUsers, FaCalendarAlt, FaHandshake } from 'react-icons/fa';

const AboutPage = () => {
  return (
    <AboutContainer>
      <Title>À Propos de CASPH ROYAL</Title>

      <Sections>
        <Card>
          <IconWrapper>
            <FaBuilding />
          </IconWrapper>
          <CardContent>
            <Subtitle>DISPOSITIONS GÉNÉRALES</Subtitle>
          </CardContent>
        </Card>

        <Card>
          <IconWrapper>
            <FaMapMarkerAlt />
          </IconWrapper>
          <CardContent>
            <Subtitle>Article 1 : Constitution et Dénomination</Subtitle>
            <Paragraph>
              Constitution d'une société coopérative simplifiée sous la dénomination : <strong>« CASPH ROYAL »</strong>.
            </Paragraph>
          </CardContent>
        </Card>

        <Card>
          <IconWrapper>
            <FaClock />
          </IconWrapper>
          <CardContent>
            <Subtitle>Article 2 : Objet et Ressort Territorial</Subtitle>
            <Paragraph>
              Promotion du développement de l'<strong>agriculture</strong>, la <strong>sylviculture</strong>, et autres activités sur <strong>N'Djamena</strong> et le <strong>Tchad</strong>.
            </Paragraph>
          </CardContent>
        </Card>

        <Card>
          <IconWrapper>
            <FaCalendarAlt />
          </IconWrapper>
          <CardContent>
            <Subtitle>Article 3 : Durée</Subtitle>
            <Paragraph>
              La coopérative a une durée de vie de <strong>99 ans</strong>.
            </Paragraph>
          </CardContent>
        </Card>

        <Card>
          <IconWrapper>
            <FaMapMarkerAlt />
          </IconWrapper>
          <CardContent>
            <Subtitle>Article 4 : Siège Social</Subtitle>
            <Paragraph>
              Le siège social est établi à <strong>NDJARI, N'Djamena</strong>.
            </Paragraph>
          </CardContent>
        </Card>

        <Card>
          <IconWrapper>
            <FaUsers />
          </IconWrapper>
          <CardContent>
            <Subtitle>Article 6 : Principes Coopératifs</Subtitle>
            <List>
              <li>Adhésion ouverte</li>
              <li>Pouvoir démocratique</li>
              <li>Participation économique</li>
              <li>Autonomie et indépendance</li>
              <li>Éducation et information</li>
              <li>Coopération</li>
              <li>Engagement communautaire</li>
            </List>
          </CardContent>
        </Card>

        <Card>
          <IconWrapper>
            <FaHandshake />
          </IconWrapper>
          <CardContent>
            <Subtitle>Assemblée Générale Constitutive</Subtitle>
            <Paragraph>
              L'assemblée constitutive a eu lieu le <strong>19 Novembre 2019</strong>.
            </Paragraph>
          </CardContent>
        </Card>
      </Sections>
    </AboutContainer>
  );
};

const AboutContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

const Title = styled.h1`
  text-align: center;
  color: #2E8B57;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const Card = styled.div`
  display: flex;
  align-items: flex-start;
  background-color: #f9f9f9;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  gap: 15px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
  }
`;

const IconWrapper = styled.div`
  font-size: 1.8rem;
  color: #004080;

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`;

const CardContent = styled.div`
  flex: 1;

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const Subtitle = styled.h2`
  margin: 0;
  color: #2E8B57;
  font-size: 1.2rem;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const Paragraph = styled.p`
  margin-top: 10px;
  line-height: 1.6;
`;

const List = styled.ul`
  margin-top: 10px;
  padding-left: 20px;
  list-style-type: disc;

  li {
    margin-bottom: 5px;
  }
`;

export default AboutPage;
